import React from "react";
import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import {
  useSnapshotExtension,
  useSnapshotExtensionTop,
} from "../../../common/controls";
import { FormControl } from "@mui/material";

type InterpreterViewProps = {
  snapshotData: any;
  // Propagated from the top-level snapshot view so nested tables can resolve
  // the snapshot-scoped file-download endpoint (/<snapshotEntityName>.data/
  // <snapshotRecordId>/<fileUuid>). Both are optional at the type level but
  // required at runtime for the download / view affordances to work.
  snapshotEntityName?: string;
  snapshotRecordId?: string;
};

export const InterpreterView: React.FC<InterpreterViewProps> = ({
  snapshotData,
}) => {
  const { langStore } = useRootStore();
  const renderExtensionTop = useSnapshotExtensionTop("Interpreter");
  const renderExtension = useSnapshotExtension("Interpreter");

  return (
    <>
      {renderExtensionTop ? renderExtensionTop(snapshotData) : null}
      <FormControl fullWidth>
        <ShowMultiLine
          label={langStore.InterpreterNameLabel}
          value={String(snapshotData?.name ?? "")}
        />
      </FormControl>
      {renderExtension ? renderExtension(snapshotData) : null}
    </>
  );
};
